import dayjs from "dayjs";
import { History, MessageSquareText, MoveRight } from "lucide-react";
import Panel, { Empty } from "./Panel";

// The last few things that happened on my leads, by me or by anyone else.
const RecentActivity = ({ items, loading, onOpen }) => (
    <Panel title="Recent on my leads" icon={History} loading={loading}>
        {!items?.length ? (
            <Empty icon={History} title="No activity yet" hint="Log a call or note on a lead and it shows up here." />
        ) : (
            <ul className="space-y-1">
                {items.map(r => (
                    <li key={r.id} onClick={() => r.customer_id && onOpen(r.customer_id)}
                        className="flex items-start gap-2.5 p-2 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700/40 cursor-pointer">
                        <span className="mt-0.5 p-1 rounded-full bg-brand-50 text-brand-600 dark:bg-brand-900/30 dark:text-brand-300">
                            {r.to_status ? <MoveRight className="h-3 w-3" /> : <MessageSquareText className="h-3 w-3" />}
                        </span>
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium text-gray-900 dark:text-white truncate">{r.customer_name}</p>
                            <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                                {r.to_status
                                    ? <>{r.from_status || "—"} → <span className="font-medium text-gray-700 dark:text-gray-200">{r.to_status}</span></>
                                    : (r.remarks || "Note")}
                                {r.user_name ? ` · ${r.user_name}` : ""}
                            </p>
                        </div>
                        <span className="text-[11px] text-gray-400 whitespace-nowrap">
                            {r.created_date ? dayjs(r.created_date).fromNow() : ""}
                        </span>
                    </li>
                ))}
            </ul>
        )}
    </Panel>
);

export default RecentActivity;
